<template>
  <footer class="footer">
    <div class="level">
      <div class="level-item has-text-centered">
        <div>
          <ul>
            <li><a href="/presse/IT4Anxiety_AVIQ.pdf" target="_blank">Presse</a></li>
            <li><a href="mailto:IT4Anxiety@saintmartin.ofc.be">Contactez-nous</a></li>
          </ul>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="">{{actualyear}} - IT4Anxiety - Interreg NWE</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      actualyear: ""
    }
  },
  mounted(){
    let date = new(Date);
    this.actualyear = date.getFullYear();
  }
}
</script>